import BookingDetails from "../venueManager/BookingDetails";
import VenueDashboard from "../venueManager/Dashboard";
import BookingList from "../venueManager/BookingList"
let id = localStorage.getItem("venueManagerBookingId")

export const allVenueManagerroutes = [
   {
    url: "",
    component: <VenueDashboard />,
  },
  {
    url: "venue-manager",
    component: <VenueDashboard />,
  },
  {
    url: `booking-details/${id}`,
    component: <BookingDetails />,
  },
  {
    url: "booking-list",
    component: <BookingList />,
  },
];
